<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Request To Reopen Receipt (ASN)
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card>
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >Request

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider class="mb-3"></v-divider>
      <v-card-text>
        <v-form ref="form">
          <div class="text-center py-0">
            <v-row no-gutters>
              <v-col cols="12" sm="4" md="4" class="pb-0">
                <v-autocomplete
                  v-model="warehouse_id"
                  label="Warehouse"
                  item-text="name"
                  item-value="id"
                  :items="warehouses"
                  outlined
                  @change="fetchClientList(warehouse_id)"
                ></v-autocomplete>
              </v-col>
              <v-col
                cols="12"
                sm="4"
                v-if="
                  userCategory.user_category === 3 ||
                  userCategory.user_category === 6
                "
                class="pb-0 pl-3"
              >
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="pb-2 pt-0 text-center"
                  @change="getStores()"
                  outlined
                ></v-autocomplete>
              </v-col>

              <v-col md="4" class="pb-0 pl-3">
                <v-autocomplete
                  v-model="infor_storer_id"
                  label="Storer Name"
                  :rules="[(v) => !!v || 'Storer Name is required.']"
                  item-text="channel_name"
                  item-value="id"
                  class="required"
                  :items="stores"
                  outlined
                  @change="getReceiptNumber"
                ></v-autocomplete>
              </v-col>
              <v-col
                md="4"
                v-if="selectedClient && infor_storer_id && warehouse_id"
                class="pb-0"
                :class="{ 'pl-3': userCategory.user_category === 1 }"
              >
                <v-autocomplete
                  v-model="receipt_key_display"
                  item-value="receipt_key"
                  item-text="receipt_key"
                  label="Select Receipt Number (ASN/PO)"
                  :rules="[
                    (v) => !!v || 'Receipt Number (ASN/PO) is required.',
                  ]"
                  class="required"
                  :items="receiptNumbers"
                  outlined
                  @change="getExternalReferenceNumber"
                ></v-autocomplete>
              </v-col>
              <v-col
                md="4"
                class="pb-0 pl-3"
                v-if="selectedClient && infor_storer_id && warehouse_id"
              >
                <v-text-field
                  v-model="receipt_no"
                  label="External Reference No"
                  :rules="[(v) => !!v || 'External Reference No is required.']"
                  class="required"
                  outlined
                  readonly
                ></v-text-field>
              </v-col>
              <v-col
                md="4"
                class="pb-0"
                :class="{
                  'pl-3':
                    infor_storer_id !== null ||
                    userCategory.user_category === 1,
                }"
              >
                <v-autocomplete
                  v-model="reason"
                  label="Select Reason For Reopening"
                  :rules="[(v) => !!v || 'Reason is required.']"
                  class="required"
                  :items="reasons"
                  item-text="text"
                  item-value="value"
                  outlined
                  multiple
                ></v-autocomplete>
              </v-col>
              <v-col
                md="4"
                class=""
                :class="{
                  'pl-3': infor_storer_id == null,
                }"
              >
                <v-text-field
                  outlined
                  v-model="comment"
                  class="required"
                  :rules="[(v) => !!v || 'Comment is required.']"
                  label="Comment"
                  maxlength="300"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row
              class="text-left mt-0"
              :class="{ 'pl-3': userCategory.user_category === 1 }"
            >
              <v-col class="pl-3">
                <v-btn
                  color="primary"
                  dark
                  :loading="fileLoader"
                  @click="upload"
                >
                  Save
                </v-btn>

                <v-btn class="ml-3" @click="close()"> Cancel </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
    getStartDate() {
      var startDate = new Date();
      startDate.setDate(startDate.getDate() + 1);
      startDate.setHours(0, 0, 0, 0);
      return startDate.toISOString().split("T")[0];
    },
  },
  created() {
    this.getwarehouse();
    if (this.userCategory.user_category === 1) {
      this.selectedClient = this.$store.getters.user.id;
    }
  },

  data() {
    return {
      date: null,
      dateMenu: false,
      clients: [],
      selectedClient: null,
      total: 0,
      file: null,
      fileLoader: false,
      dialog: false,
      statusType: null,
      downloader: false,
      uploadRes: {},
      clientLoader: false,
      warehouses: [],
      receipt_no: "",
      warehouse: "",
      infor_storer_id: null,
      stores: [],
      receipt_key_display: null,
      getExternalReferenceNumbers: [],
      reasons: [
        { text: "Add Stocks", value: 1 },
        { text: "Correction On received Qty", value: 2 },
        { text: "Production Date Correction", value: 3 },
        { text: "Exp Date Correction", value: 4 },
        { text: "Batch/Lot Correction", value: 5 },
        { text: "BOE correction", value: 6 },
        { text: "Item Code changes", value: 7 },
      ],
      reason: [],
      receiptNumbers: [],
    };
  },

  methods: {
    ...mapActions([
      "fetchClient",
      "snackBar",
      "getInforWarehouseList",
      "getWarehouseStores",
      "getReceiptNumberList",
      "addRequest",
    ]),
    getExternalReferenceNumber() {
      this.receipt_no = this.receiptNumbers.find(
        (item) => item.receipt_key == this.receipt_key_display
      )?.receipt_no;
    },
    getReceiptNumber() {
      if (this.selectedClient && this.warehouse_id && this.infor_storer_id) {
        let payload = {
          client_id: this.selectedClient,
          warehouse_id: this.warehouse_id,
          channel_id: this.infor_storer_id,
          type: 2,
        };
        this.getReceiptNumberList(payload).then((response) => {
          this.receiptNumbers = response.data;
        });
      }
    },
    getwarehouse() {
      this.storer_key = "";
      this.sku = null;
      this.warehouse_id = null;

      this.getInforWarehouseList().then((response) => {
        this.warehouses = response.data.result;
      });
    },

    upload() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      let id = this.receiptNumbers.find(
        (item) => item.receipt_key == this.receipt_key_display
      )?.id;
      let infor_storer_id = this.stores.find(
        (item) => item.id == this.infor_storer_id
      )?.infor_storer_id;
      let reasonCopy = [...this.reason];

      let payload = {
        client_id_id: this.selectedClient,
        inbound_id_id: id,
        warehouse_id_id: this.warehouse_id,
        infor_storer_id: infor_storer_id,
        channel_id_id: this.infor_storer_id,
        receipt_key: this.receipt_key_display,
        external_reference_number: this.receipt_no,
        reason_to_reopen: reasonCopy.join(","),
        comments: this.comment,
      };

      this.addRequest(payload)
        .then((res) => {
          this.fileLoader = false;
          this.snackBar({
            color: "success",
            message: res.data.message,
          });

          this.$refs.form.reset();
          this.date = null;
          this.$router.push("/asnlist");
        })
        .catch(() => {
          this.fileLoader = false;
          this.reason = this.reason.split(",");
        });
    },
    close() {
      this.selectedClient = null;
      this.file = null;
      this.fileLoader = false;
      this.$refs.form?.reset();
      this.date = null;
      this.$router.push("/asnlist");
    },
    fetchClientList() {
      this.clients = [];
      this.stores = [];
      if (
        this.userCategory.user_category === 3 ||
        this.userCategory.user_category === 6
      ) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
          type: "warehouse",
          warehouse_id: this.warehouse_id,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    getStores() {
      let payload = {
        client_id: this.selectedClient,
        warehouse_id: this.warehouse_id,
      };
      if (this.selectedClient && this.warehouse_id) {
        this.getWarehouseStores(payload).then((res) => {
          this.stores = res.data;
        });
      } else {
        this.stores = [];
      }
    },
    listPage() {
      this.$router.push({
        name: "inboundorderStatusList",
        params: {
          type: "inbound_upload",
        },
      });
    },
  },
};
</script>
<style>
.custom .v-text-field {
  padding-top: 0;
}
</style>
